
import { ref, toRaw, computed, watch, reactive } from 'vue'
import { useStore } from 'vuex'
import { setNoEmptyForm } from '@/util/common'
export default () => {
  const searchForm:any = ref({})
  const sortForm: any = reactive({
    ascs: [],
    descs: []
  })
  const store = useStore()
  const customerShopId = store.getters.curShop
  const filterData = computed(() => {
    if (!sortForm.ascs.length && !sortForm.descs.length) {
      sortForm.descs = ['create_time']
    }
    return {
      ...setNoEmptyForm(toRaw(searchForm.value)),
      ...sortForm,
      customerShopId
    }
  })
  return [
    searchForm,
    sortForm,
    filterData
  ]
}
